import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { emitNotification } from "@impero-com/ui";
import * as Sentry from "@sentry/react";
import { useMutation } from "@tanstack/react-query";

import { deleteBlobsBlobId } from "api/generated/blobs/blobs";

interface DeleteBlobMutationVars {
    id: string;
}

export type DeleteBlobAction =
    | {
          kind: "DELETE_BLOB";
      }
    | {
          kind: "DO_NOT_DELETE_BLOB";
      };

export const useDeleteBlobMutation = (action: DeleteBlobAction) =>
    useMutation({
        mutationKey: ["uploadBlob"],
        mutationFn: async (vars: DeleteBlobMutationVars) => {
            const { id } = vars;
            switch (action.kind) {
                case "DELETE_BLOB":
                    await deleteBlobsBlobId(id);
                    break;
                case "DO_NOT_DELETE_BLOB":
                    break;
                default:
                    assertNever(action);
            }
        },
        onError: (err) => {
            emitNotification("error", t("File_Upload_Delete_Failed"));

            // We don't expect delete to fail. This may be an error in file state handling
            Sentry.captureException(err);
        },
    });
